module.exports = require('./helpers/bundle-url').getBundleURL('dMC83') + "logo-dark.eefe0b7f.svg";